module.exports = __webpack_public_path__ + "static/media/refresh.c6e88973.svg";